import React from 'react';
import styles from './BtnSwitch.module.css';

const BtnSwitch = ({
                       active,
                       waiting = false,
                       activeLabel = "",
                       inactiveLabel = "",
                       waitingLabel = "",
                       onToggle,
                       id,
                       name,
                       classNames = "",
                       classNamesLabel = "",
                   }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        onToggle();
    };

    const label = active ? (waiting ? waitingLabel : activeLabel) : inactiveLabel;

    const sliderClassName = `${styles.slider} ${waiting ? styles.waiting : ''}`;
    const className = `${classNames} ${sliderClassName}`;
    const labelClassName = `${classNamesLabel} ${styles.label}`;

    return (
        <div className={styles.btnSwitch} onClick={handleClick}>
            <label htmlFor={name} className={labelClassName}>{label}</label>
            <input
                type="checkbox"
                id={id}
                name={name}
                checked={active}
                onChange={() => {}}
                className={styles.checkbox}
            />
            <span className={className}></span>
        </div>
    );
};

export default BtnSwitch;
